export default __webpack_public_path__ + "static/media/logo.8db9b635.png";